import {
	ChangeDetectionStrategy,
	Component,
	OnInit,
	inject,
	signal,
} from '@angular/core';
import type {
	OperatorReservation,
	ReservationStatus,
} from '@pressteaze/domain';
import { OperatorReservationCardComponent } from '../reservation/reservation-card/reservation-card.component';
import {
	OperatorReservationControlsComponent,
	type ReservationCreateMode,
} from '../reservation/reservation-controls/reservation-controls.component';
import {
	OperatorReservationEditorComponent,
	type ReservationEditorMode,
} from '../reservation/reservation-editors/reservation-editor.component';
import { OperatorWalkInEditorComponent } from '../reservation/reservation-editors/walk-in-editor.component';
import { OperatorStateService } from '../../services/state-services/operator-state.service';

@Component({
	selector: 'app-operator-home',
	imports: [
		OperatorReservationControlsComponent,
		OperatorReservationCardComponent,
		OperatorReservationEditorComponent,
		OperatorWalkInEditorComponent,
	],
	templateUrl: './operator-home.component.html',
	styleUrl: './operator-home.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperatorHomeComponent implements OnInit {
	readonly operatorStateSrv = inject(OperatorStateService);

	readonly editorMode = signal<ReservationEditorMode | 'walk_in' | null>(null);
	readonly editing = signal<OperatorReservation | null>(null);
	readonly expandedReservationId = signal<string | null>(null);

	ngOnInit(): void {
		void this.operatorStateSrv.activateShift();
	}

	openCreate(mode: ReservationCreateMode): void {
		this.editing.set(null);
		this.editorMode.set(mode);
	}

	openEdit(reservation: OperatorReservation): void {
		if (reservation.status === 'cancelled' || reservation.status === 'expired')
			return;
		this.editing.set(reservation);
		this.editorMode.set('edit');
	}

	closeEditor(): void {
		this.editorMode.set(null);
		this.editing.set(null);
	}

	async transition(reservation: OperatorReservation, status: ReservationStatus): Promise<void> {
		await this.operatorStateSrv.transition(reservation, status);
	}

	toggleReservation(reservationId: string): void {
		this.expandedReservationId.update((current) =>
			current === reservationId ? null : reservationId,
		);
	}
}
